import { paths } from 'ogp/paths';
import { mapOgpSidebarItems, withSectionChildren } from './ogp-sidebar-section-helpers';
import { OgpSidebarItems } from './ogp-sidebar-items.types';

export const filterWorkforceManagementSidebarItems = (
  sidebarItems: OgpSidebarItems,
  offersEmployeeWork: boolean | undefined
): OgpSidebarItems => {
  if (offersEmployeeWork) {
    return sidebarItems;
  }

  return mapOgpSidebarItems(sidebarItems, (section) =>
    section.key === 'workforce-management'
      ? withSectionChildren(
          section,
          section.children.filter((child) => child.path !== paths.Workforce.path)
        )
      : section
  );
};
